import { TooltipWrapper } from 'components/TooltipWrapper'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const SubmenuContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const SubTogglesContainer = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  left: 100%;
  top: 0;
  display: flex;
  flex-direction: row;
  gap: 0px;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  transition: opacity 0.2s ease-in-out;
`

interface SubmenuProps {
  children: React.ReactNode
  label: string
  icon: React.ReactNode
  handleClick?: () => void
  selected?: boolean
  forceOpen?: boolean
}

export const SubmenuComponent: React.FC<SubmenuProps> = ({
  children,
  label,
  icon,
  handleClick,
  selected,
  forceOpen = false,
}) => {
  const [showSubToggles, setShowSubToggles] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleMouseLeave = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.relatedTarget as Node)
      ) {
        setShowSubToggles(false)
      }
    }

    const container = containerRef.current
    if (container) {
      container.addEventListener('mouseleave', handleMouseLeave)
    }

    return () => {
      if (container) {
        container.removeEventListener('mouseleave', handleMouseLeave)
      }
    }
  }, [])

  const clickHandler = handleClick ? handleClick : () => {}

  return (
    <SubmenuContainer
      ref={containerRef}
      onMouseEnter={() => setShowSubToggles(true)}>
      <TooltipWrapper side='top' offset={5} label={label}>
        <ViewToggle
          onClick={clickHandler}
          hasSubmenu={true}
          selected={selected}>
          {icon}
        </ViewToggle>
      </TooltipWrapper>
      <SubTogglesContainer $isVisible={showSubToggles || forceOpen}>
        {children}
      </SubTogglesContainer>
    </SubmenuContainer>
  )
}
